module.exports = {
  siteTitle: 'Ginfo Overwatch Edition', // Site title.
  siteTitleAlt: 'GatsbyJS Advanced Starter', // Alternative site title for SEO.
  siteLogo: '/logos/logo-1024.png', // Logo used for SEO and manifest.
  siteUrl: 'https://overwatch.ginfo.gg', // Domain of your website without pathPrefix.
  siteDescription: 'Ginfo is the companion that every Overwatch player needs. Have your Overwatch Profile and Statistics always by your side. Check hero values like damage numbers, cooldowns and more!', // Website description used for RSS feeds/meta description tag.
  siteKeywords: `ginfo, overwatch, heroes, hero, details, strategies, maps, statistics, blizzard, guide, wiki, companion, stats, cooldown, damage`,
  siteFBAppID: undefined, // FB Application ID for using app insights
  googleAnalyticsID: undefined, // GA tracking ID.
  userTwitter: '@ginfo_gg', // Optionally renders "Follow Me" in the UserInfo segment.
  copyright: 'Copyright © 2017. Innovaptor OG', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#24476c', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff', // Used for setting manifest background color.
}



// WEBPACK FOOTER //
// ./data/SiteConfig.js